import * as Accordion from "@radix-ui/react-accordion";
import { EmailLink } from "./EmailLink";
import { Plus } from "lucide-react";
import { home } from "../content/home";

export function FAQSection() {
  return (
    <section id="faq" className="scroll-mt-20 px-4 py-24 sm:px-6 lg:py-28">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <h2 className="font-serif text-[clamp(2.25rem,4.5vw,3.5rem)] font-medium leading-[1.02] tracking-[-0.015em] text-char">
            Frequently asked questions
          </h2>
          <p className="mt-5 font-sans text-lg leading-relaxed text-char/75">
            Everything you might want to know before signing up. Still curious?{" "}
            <EmailLink email="hello@intakall.io" className="rounded font-semibold text-char underline decoration-char/30 underline-offset-[6px] hover:decoration-char focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500">
              Ask us anything.
            </EmailLink>
          </p>
        </div>

        <Accordion.Root type="single" collapsible className="border-t border-char/20">
          {home.faq.map(({ q, a }, index) => (
            <Accordion.Item key={q} value={`q-${index}`} className="group border-b border-char/20">
              <Accordion.Header>
                <Accordion.Trigger className="flex w-full items-center justify-between gap-6 rounded py-5 text-left font-serif text-[22px] leading-snug text-char transition-colors hover:text-brand-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500">
                  {q}
                  <Plus
                    className="h-5 w-5 shrink-0 text-char/50 transition-transform duration-200 group-data-[state=open]:rotate-45 group-data-[state=open]:text-brand-600"
                    aria-hidden="true"
                  />
                </Accordion.Trigger>
              </Accordion.Header>
              <Accordion.Content className="overflow-hidden">
                <p className="max-w-2xl pb-6 pr-10 font-sans text-base leading-relaxed text-char/75">{a}</p>
              </Accordion.Content>
            </Accordion.Item>
          ))}
        </Accordion.Root>
      </div>
    </section>
  );
}
